import { p as proxyCustomElement, H, h } from './p-23afa4c1.js';
import { d as defineCustomElement$5 } from './p-eddedf58.js';
import { d as defineCustomElement$4 } from './p-7dc710df.js';
import { d as defineCustomElement$3 } from './p-8938db8f.js';
import { d as defineCustomElement$2 } from './p-0f8558ea.js';
import { b as bem } from './p-a05fe53c.js';
import { h as hasNamedSlot } from './p-bde29a8a.js';
import { i as isResponsiveProperty, p as parseResponsiveProperty } from './p-1d1540b7.js';

const cosmosLinkItemCss = ".cosmos-link-item{--cosmos-asset-item-base-gap:var(--cosmos-link-item-gap);--cosmos-asset-item-base-headline-color:var(--cosmos-link-item-headline-color);--cosmos-asset-item-base-headline-font-family:var(--cosmos-link-item-headline-font-family);--cosmos-asset-item-base-headline-font-size:var(--cosmos-link-item-headline-font-size);--cosmos-asset-item-base-headline-font-style:var(--cosmos-link-item-headline-font-style);--cosmos-asset-item-base-headline-font-weight:var(--cosmos-link-item-headline-font-weight);--cosmos-asset-item-base-headline-letter-spacing:var(--cosmos-link-item-headline-letter-spacing);--cosmos-asset-item-base-headline-line-height:var(--cosmos-link-item-headline-line-height);--cosmos-asset-item-base-headline-text-transform:var(--cosmos-link-item-headline-text-transform);--cosmos-asset-item-base-meta-text-primary-color:var(--cosmos-link-item-url-color);--cosmos-asset-item-base-meta-text-primary-font-family:var(--cosmos-link-item-url-font-family);--cosmos-asset-item-base-meta-text-primary-font-size:var(--cosmos-link-item-url-font-size);--cosmos-asset-item-base-meta-text-primary-font-style:var(--cosmos-link-item-url-font-style);--cosmos-asset-item-base-meta-text-primary-font-weight:var(--cosmos-link-item-url-font-weight);--cosmos-asset-item-base-meta-text-primary-letter-spacing:var(--cosmos-link-item-url-letter-spacing);--cosmos-asset-item-base-meta-text-primary-line-height:var(--cosmos-link-item-url-line-height);--cosmos-asset-item-base-meta-text-primary-text-transform:var(--cosmos-link-item-url-text-transform);--cosmos-asset-item-base-meta-text-additional-color:var(--cosmos-link-item-additional-info-color);--cosmos-asset-item-base-meta-text-additional-font-family:var(--cosmos-link-item-additional-info-font-family);--cosmos-asset-item-base-meta-text-additional-font-size:var(--cosmos-link-item-additional-info-font-size);--cosmos-asset-item-base-meta-text-additional-font-style:var(--cosmos-link-item-additional-info-font-style);--cosmos-asset-item-base-meta-text-additional-font-weight:var(--cosmos-link-item-additional-info-font-weight);--cosmos-asset-item-base-meta-text-additional-letter-spacing:var(--cosmos-link-item-additional-info-letter-spacing);--cosmos-asset-item-base-meta-text-additional-line-height:var(--cosmos-link-item-additional-info-line-height);--cosmos-asset-item-base-meta-text-additional-text-transform:var(--cosmos-link-item-additional-info-text-transform)}.cosmos-link-item__url-text{min-width:0;width:100%}.cosmos-link-item__image{--cosmos-image-border-radius:var(--cosmos-link-item-image-radius, 4px);height:100%;width:100%}.cosmos-link-item__additional-info{display:-ms-flexbox;display:flex}.cosmos-link-item__additional-info ::slotted([slot=additional-info-prefix]){-webkit-margin-end:4px;margin-inline-end:4px}.cosmos-link-item__icon{--cosmos-icon-size:16px;-ms-flex-item-align:center;align-self:center;-ms-flex-negative:0;flex-shrink:0;-webkit-margin-end:4px;margin-inline-end:4px}:host-context([dir=rtl]) .cosmos-link-item__icon{-webkit-transform:scaleX(-1);transform:scaleX(-1)}:host(:dir(rtl)) .cosmos-link-item__icon{-webkit-transform:scaleX(-1);transform:scaleX(-1)}.cosmos-link-item__url-domain{direction:ltr;display:-ms-inline-flexbox;display:inline-flex;max-width:100%}.cosmos-link-item__url-domain>:first-child{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
const CosmosLinkItemStyle0 = cosmosLinkItemCss;

const generateClassNames = bem('cosmos-link-item');
const CosmosLinkItem$1 = /*@__PURE__*/ proxyCustomElement(class CosmosLinkItem extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.getDomain = (url) => {
            if (url) {
                try {
                    const protocol = url.includes('.') && !/^https?:\/\//.test(url) ? 'https://' : '';
                    return new URL(`${protocol}${url}`).hostname.replace(/^www\./, '');
                }
                catch (_a) {
                    return;
                }
            }
        };
        this.splitDomain = (url) => {
            const [firstPart, secondPart] = url.split('.');
            const lastChar = firstPart[firstPart.length - 1];
            return [firstPart.slice(0, -1), `${lastChar}.${secondPart}`];
        };
        this.additionalInfo = undefined;
        this.appearance = undefined;
        this.headline = undefined;
        this.href = undefined;
        this.image = undefined;
        this.rel = undefined;
        this.size = 'small';
        this.target = undefined;
    }
    hasAdditionalInfoSlot() {
        return hasNamedSlot(this.element, 'additional-info-prefix');
    }
    getSizeClasses() {
        return this.size && isResponsiveProperty(this.size) ? parseResponsiveProperty(this.size) : this.size;
    }
    render() {
        const domain = this.href && this.getDomain(this.href);
        const domainParts = domain && this.splitDomain(domain);
        return (h("cosmos-asset-item-base", { key: '984e83331dd68aef40a3cc469cc47ffcfe3ff685', appearance: this.appearance, class: generateClassNames({
                size: this.getSizeClasses(),
            }), exportparts: "base: base, headline: headline, meta-text-primary: url, additional-info: additional-info", headline: this.headline, headlineClamp: 2, metaTextAdditional: this.additionalInfo, href: this.href, rel: this.rel, target: this.target, size: this.size }, domainParts && (h("cosmos-text", { class: generateClassNames('url-text'), size: "x-small", slot: "meta-text-primary" }, h("div", { class: generateClassNames('url-domain'), "aria-label": domain }, h("span", { "aria-hidden": "true" }, domainParts[0]), h("span", { "aria-hidden": "true" }, domainParts[1])))), h("cosmos-image", { key: '36e4b3036d6bc99aff84e77f1ae4a911092e2f9d', class: generateClassNames('image'), image: this.image, imageAlt: "", exportparts: "base: image", slot: "image" }), this.href && (h("cosmos-icon-external-link", { class: generateClassNames('icon'), slot: "meta-text-primary-prefix" })), this.hasAdditionalInfoSlot() && (h("span", { "aria-hidden": "true", slot: "meta-text-additional-info-prefix", class: generateClassNames('additional-info') }, h("slot", { name: "additional-info-prefix" })))));
    }
    get element() { return this; }
    static get style() { return CosmosLinkItemStyle0; }
}, [1, "cosmos-link-item", {
        "additionalInfo": [513, "additional-info"],
        "appearance": [513],
        "headline": [513],
        "href": [513],
        "image": [513],
        "rel": [513],
        "size": [513],
        "target": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-link-item", "cosmos-asset-item-base", "cosmos-icon-external-link", "cosmos-image", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-link-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosLinkItem$1);
            }
            break;
        case "cosmos-asset-item-base":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "cosmos-icon-external-link":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "cosmos-image":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosLinkItem = CosmosLinkItem$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosLinkItem, defineCustomElement };
